module.exports = __webpack_public_path__ + "static/media/robotOfflineAvatar.449c1f02.svg";